module.exports = __webpack_public_path__ + "27UD88-W_icon.svg?d8dfdea2c200e23b604370bd8f043de5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/27UD88-W_icon.svg
// module id = 193
// module chunks = 0